function isEmpty(value) {
    return value === null
        || value === undefined
        || value === ""
        || (
            Array.isArray(value)
            && value?.length == 0
        )
        || (
            Object.getPrototypeOf(value ?? {}) === Object.prototype
            && Object.keys(value ?? {})?.length == 0
        )
        ;
}

function required(value) {
    return isEmpty(value)
        ? "Este campo é obrigatório."
        : true;
}

function requiredIf(value, condition) {
    if (!condition) {
        return true;
    }

    return required(value);
}

function requiredIfAny(value, conditions = []) {
    return requiredIf(value, conditions.some(Boolean));
}

function requiredIfAll(value, conditions = []) {
    return requiredIf(value, conditions.every(Boolean));
}

function valueMustBeEqual(value, comparison, strict = false) {
    const isEqual = strict
        ? value === comparison
        : value == comparison;

    return isEqual
        ? true
        : `O valor deste campo tem de ser '${comparison}', atualmente é: '${value}'.`;
}

function valueMustBeDifferent(value, comparison, strict = false) {
    const isDifferent = strict
        ? value !== comparison
        : value != comparison;

    return isDifferent
        ? true
        : `O valor deste campo não pode ser '${value}'.`;
}

function valueMustBelongTo(value, allowedValues = [], strict = false) {
    if (isEmpty(value)) {
        return true;
    }

    const belongs = allowedValues.some((allowed) => {
        return strict
            ? value === allowed
            : value == allowed;
    });

    return belongs
        ? true
        : `Valor '${value}' inválido para este campo. Valores permitidos: ${allowedValues.join(", ")}.`;
}

function valueCannotBelongTo(value, forbiddenValues = [], strict = false) {
    if (isEmpty(value)) {
        return true;
    }

    const isForbidden = forbiddenValues.some((forbidden) => {
        return strict
            ? value === forbidden
            : value == forbidden;
    });

    return isForbidden
        ? `Valor '${value}' inválido para este campo. Valores proibidos: ${forbiddenValues.join(", ")}.`
        : true;
}

export default {
    isEmpty, 
    required, 
    requiredIf,
    requiredIfAny,
    requiredIfAll,
    valueMustBeEqual, 
    valueMustBelongTo, 
    valueCannotBelongTo, 
    valueMustBeDifferent
}